import { useState } from "react";
import {
  ToolbarButton,
  Body1Strong,
  Body1Stronger,
  Dialog,
  DialogSurface,
  DialogTitle,
  DialogBody,
  DialogActions,
  DialogTrigger,
  Button,
  DialogContent,
  Table,
  TableBody,
  TableHeader,
  TableHeaderCell,
  TableRow,
  TableCell,
  useToastController,
} from "@fluentui/react-components";
import { useGlobalStatus } from "../../services/GlobalStatusProvider";
import { format, startOfMonth, endOfMonth } from "date-fns";
import { TOASTER_ID } from "../../services/toastUtils";
import { showErrorToast } from "../../services/toastUtils";
import { GetA23MonthlyEntries } from "../../services/apiService";
import {formatDisplayDate} from '../../services/TimeFunctions';


export default function MonthlyReview() {
  const [open, setOpen] = useState(false);
  const { currentWeekStart, useStyles, startLoad, endLoad, dateToggle }= useGlobalStatus();
  const styles = useStyles();
  const { dispatchToast } = useToastController(TOASTER_ID);
  const [data, setData] = useState([]);
  const monthStart = startOfMonth(currentWeekStart);
  const monthEnd = endOfMonth(currentWeekStart);

  var monthTotal = 0;

  function calculateTotals  (week) {
    const totalsPerDay = Array.from({ length: 8 }, (_, dayIndex) =>
      week.projects.reduce((sum, project) => sum + (project.dailyEntries?.[dayIndex]?.minutes ?? 0), 0)
    );
    totalsPerDay[7] = week.projects.reduce((sum, project) => sum + (project.totalMinutes ?? 0), 0);

    return totalsPerDay.map((minutes, i) => (
      <TableCell>{formatDisplayDate(minutes, dateToggle)}</TableCell>
    ));
  }

  const openMonthlyReview = async () => {
    try {
      startLoad();
      try {
        setData([]);
        const response = await GetA23MonthlyEntries(currentWeekStart);
        setData(response);
      } catch {
        showErrorToast(dispatchToast, "Failed to get timecodes");
      }
      endLoad();
      setOpen(true);
    } catch (ex) {
      console.error(ex);
      endLoad();
    }
  };

  return (
    <div style={{ display: "inline-block", float: "right" }}>
      <Dialog open={open} onOpenChange={(e, { open }) => setOpen(open)} >
        <DialogTrigger>
          <ToolbarButton 
          className={styles.buttonPrimary}
          onClick={()=> {openMonthlyReview()}}>
            Review Month
          </ToolbarButton>
        </DialogTrigger>

        <DialogSurface style={{ width: '90vw', maxWidth: '1200px' }}>
          <DialogBody>
            <DialogTitle>Month of {format(currentWeekStart, "MMMM")}</DialogTitle>
            <DialogContent>
              {data.map((week, weekIndex) => (
                <Table className="monthly-review-table">
                  <TableHeader>
                    <TableHeaderCell>Project</TableHeaderCell>
                    {week.projects[0]?.dailyEntries?.map((day) => (
                      <TableHeaderCell>
                        {format(day.date, "EEE dd MMM")}
                      </TableHeaderCell>
                    ))}
                    <TableHeaderCell>Total</TableHeaderCell>
                  </TableHeader>
                  
                  <TableBody>
                    {week.projects.map((project) => {
                      monthTotal += project.totalMinutes;
                      if (project.totalMinutes <= 0) return null;
                      return (
                        <TableRow>
                          <TableCell>{project.projectName}</TableCell>
                          {project.dailyEntries.map((day) => (
                            (new Date(day.date) >= new Date(monthStart) && new Date(day.date) < new Date(monthEnd)) ? (
                            <TableCell>{formatDisplayDate(day.minutes, dateToggle)}</TableCell>
                          ) : <TableCell/>
                          ))}
                          <TableCell>
                            <strong>{formatDisplayDate(project.totalMinutes, dateToggle)}</strong>
                          </TableCell>
                        </TableRow>
                    );})}
                    <TableRow>
                      <TableCell>Total</TableCell>
                      {calculateTotals(week)}
                    </TableRow>
                  </TableBody>
                </Table>
              ))}
            <div style={{textAlign: 'right'}}>
              <Body1Strong>Month Total </Body1Strong>
              <Body1Stronger>{formatDisplayDate(monthTotal, dateToggle)}</Body1Stronger>
            </div>
            </DialogContent>
            <DialogActions>
              <Button appearance="secondary" onClick={() => setOpen(false)}>
                Close
              </Button>
            </DialogActions>
          </DialogBody>
        </DialogSurface>
      </Dialog>
    </div>
  );
}
